module.exports = __webpack_public_path__ + "static/media/Image1.ebb8dc75.png";